document.addEventListener("DOMContentLoaded", function() {
  // check if timeline exists on this page
  const timeline = document.querySelector(".Timeline");
  if (!timeline) return;

  const navItems = document.querySelectorAll(".Timeline__NavItem");
  const items = document.querySelectorAll(".Timeline__Item");

  navItems.forEach((nav, index) => {
    nav.addEventListener("click", (e) => {
      e.preventDefault();

      // remove active state
      navItems.forEach(n => n.classList.remove("is-selected"));
      items.forEach(i => i.classList.remove("is-selected"));

      // add active state
      nav.classList.add("is-selected");
      items[index].classList.add("is-selected");
    });
  });
});
